import React, { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import DATA from "../../translation/translate-es.json";
import "./social-dock.scss";

// SVGs Inline para GitHub, LinkedIn y X (Twitter)
const GithubIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
  </svg>
);

const LinkedinIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
    <rect x="2" y="9" width="4" height="12"></rect>
    <circle cx="4" cy="4" r="2"></circle>
  </svg>
);

const XIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4l11.733 16h4.429l-11.733-16z" fill="currentColor" stroke="none"></path>
    <path d="M4 20l6.768-6.768m2.46-2.46L20 4"></path>
  </svg>
);


function DockItem({ mouseX, children, href, label }: { mouseX: any, children: React.ReactNode, href: string, label: string }) {
  const ref = useRef<HTMLAnchorElement>(null);

  const distance = useTransform(mouseX, (val: number) => {
    const bounds = ref.current?.getBoundingClientRect() ?? { x: 0, width: 0 };
    return val - bounds.x - bounds.width / 2;
  });

  const widthSync = useTransform(distance, [-150, 0, 150], [40, 55, 40]);
  const width = useSpring(widthSync, { mass: 0.1, stiffness: 150, damping: 12 });

  return (
    <motion.a
      ref={ref}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      style={{ width, height: width }} // Animar alto y ancho igual para mantener círculo
      className="dock-item"
      whileHover={{ y: -10 }}
      whileTap={{ scale: 0.9 }}
    >
      <div className="dock-icon-wrapper">
        {children}
      </div>
      <span className="tooltip">{label}</span>
    </motion.a>
  );
}

export const SocialDock = () => {
  const mouseX = useMotionValue(Infinity);
  const URL = DATA.urls;

  return (
    <motion.div
      className="social-dock"
      onMouseMove={(e) => mouseX.set(e.pageX)}
      onMouseLeave={() => mouseX.set(Infinity)}
    >
      <DockItem mouseX={mouseX} href={URL.github} label="GitHub">
        <GithubIcon />
      </DockItem>
      <DockItem mouseX={mouseX} href={URL.linkedin} label="LinkedIn">
        <LinkedinIcon />
      </DockItem>
      <DockItem mouseX={mouseX} href={URL.x} label="X (Twitter)">
        <XIcon />
      </DockItem>
    </motion.div>
  );
};

